/**
  * @class meleActorCrossHair
  * @description
  * Implements `<mele-actor-crosshair>` custom web element for showing cross hair above the video
  */

import meleActor from 'meleActor'

const PROPERTIES = _.extend({}, {
  videosize: { description: 'video resolution: WIDTHxHEIGHT', type: 'string', readonly: true },
}, meleActor._properties)

export default class meleActorCrossHair extends meleActor {
  async init() {
    this.elSvg = this.appendChildren({ tag: 'svg', viewBox: '0 0 100 100', html: '<path d="M0 50 L 100 50 M50 0 L 50 100"></path>' })
    this.elPath = this.elSvg.find('path')
    super.init()
  } // init

  videosizeChanged(new_value) {
    const [w, h] = String(new_value).split('x')
    if(!(w>0 && h>0)) return
    const w2 = Math.floor(w/2)
    const h2 = Math.floor(h/2)
    this.elSvg.setAttribute('viewBox', `0 0 ${w} ${h}`)
    this.elSvg.setAttribute('width', w)
    this.elSvg.setAttribute('height', h)
    this.elPath.setAttribute('d', `M0 ${h2} L${w} ${h2} M${w2} 0 L${w2} ${h}`)
  } // videosizeChanged
} // class meleActorCrossHair

meleActorCrossHair._properties = PROPERTIES
meleActorCrossHair.observedAttributes = _.keys(PROPERTIES)
window.customElements.define('mele-actor-crosshair', meleActorCrossHair)
